import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import CertBadges from './components/CertBadges';
import ServicesOverview from './components/ServicesOverview';
import HomeIndustries from './components/HomeIndustries';
import HomeClients from './components/HomeClients';
import HomeCTA from './components/HomeCTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <CertBadges />
        <ServicesOverview />
        <HomeIndustries />
        <HomeClients />
        <HomeCTA />
      </main>
      <Footer />
    </div>
  );
}
